import { XIcon } from 'lucide-react'

import { Button } from '@/components/lemmala-design-system/button/button'
import { TABLE_FILTER_BAR_LABELS } from '@/components/lemmala-design-system/table/labels'
import { filterRemoveButtonVariants } from '@/components/lemmala-design-system/table/variants'

/** Removes the filter chip from the bar entirely. */
export const AgFilterRemoveButton = ({
  hasSelection,
  onRemove,
}: {
  hasSelection: boolean
  onRemove: () => void
}) => (
  <Button
    variant='ghost'
    size='icon'
    className={filterRemoveButtonVariants({ state: hasSelection ? 'selected' : 'unselected' })}
    onClick={onRemove}
    title={TABLE_FILTER_BAR_LABELS.removeFilter}
  >
    <XIcon className='size-4' />
  </Button>
)
